/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
        packageUrl:''
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_PACKAGE_TOKEN({state, commit, dispatch, rootState}, args){
        let gameCode=rootState.$helper.helper.getGameCode().game_code;
        let pay_package_token=rootState.$helper.cookie.get('pay_package_token_'+gameCode);
        if(_.isEmpty(pay_package_token)){
            let url=rootState.$config.api.plugin.package_token;

            url= _.replace(url,'{game_code}',gameCode);
            rootState.$helper.request.get(url,'').then(function(data){
                commit('PRIVATE_LOADING',false,{root: true});
                pay_package_token=data.data.access_token;
                if(typeof(pay_package_token)==='undefined'){
                    pay_package_token='';
                }
                rootState.$helper.cookie.set('pay_package_token_'+gameCode,pay_package_token,{'expires':5});
                let finalUrl=rootState.$config.pay_package_url+"?token="+pay_package_token;
                commit('_setPackageToken',finalUrl);

            }).catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
                commit('PRIVATE_LOADING', false, {root: true});
            });
        }else{
            let finalUrl=rootState.$config.pay_package_url+"?token="+pay_package_token;
            commit('_setPackageToken',finalUrl);
        }


    }

};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {

};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _setPackageToken(state,args){
        state.packageUrl=args;
        console.log(state.packageUrl);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/payPackageSetting.js